import React from "react";
import PropTypes from "prop-types";

export default function Arrow2(props) {
  return (
    // <svg
    //   onClick={props.onClick}
    //   className={props.className}
    //   width={props.width}
    //   height={props.height}
    //   viewBox={`0 0 ${props.width} ${props.height}`}
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M1.66667 0L0 1.71875L9 11L18 1.71875L16.3333 0L9 7.5625L1.66667 0Z"
    //     fill={props.fill}
    //   />
    // </svg>
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.2963 0L0 1.25L7 8L14 1.25L12.7037 0L7 5.5L1.2963 0Z"
        fill="#063AC9"
      />
    </svg>
  );
}
Arrow2.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  // width: PropTypes.number,
  // height: PropTypes.number,
  onClick: PropTypes.func
};
Arrow2.defaultProps = {
  className: "",
  // fill: "#3062EB",
  fill: "#292D37",
  // width: 18,
  // height: 11,

  onClick: () => null
};
